import React from "react";
import {Link} from "gatsby";
import Logo from "../images/logo.svg";

function Navigation() {
  return (
    <nav id="header" className={"fixed text-white w-full z-30 top-0 bg-white text-gray-900 shadow text-black"}>
      <div className="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
        <div className="pl-4 flex items-center">
          <Link className="toggleColour no-underline hover:no-underline font-bold text-2xl lg:text-4xl flex" to="/">
            I <img src={Logo} className="w-16 mx-2" alt={"ILOX"}/> X
          </Link>
        </div>
        <div className="block lg:hidden pr-4">
          <button id="nav-toggle" className="flex items-center p-1 text-orange-800 hover:text-gray-900">
            <svg className="fill-current h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
            </svg>
          </button>
        </div>
        <div className="w-full flex-grow lg:flex lg:items-center lg:w-auto hidden lg:block mt-2 lg:mt-0 bg-white lg:bg-transparent p-4 lg:p-0 z-20" id="nav-content">
          <ul className="list-reset lg:flex justify-end flex-1 items-center">
            <li className="mr-3">
              <Link className="inline-block no-underline hover:text-gray-800 hover:text-underline py-2 px-4" to="/#about">About</Link>
            </li>
            <li className="mr-3">
              <Link className="inline-block no-underline hover:text-gray-800 hover:text-underline py-2 px-4" to="/#faq">F.A.Q.</Link>
            </li>
            <li className="mr-3">
              <Link className="inline-block no-underline hover:text-gray-800 hover:text-underline py-2 px-4" to="/#blog">Blog</Link>
            </li>
            <li className="mr-3">
              <Link className="inline-block no-underline hover:text-gray-800 hover:text-underline py-2 px-4" to="/#support">Donate</Link>
            </li>
            <li className="mr-3">
              <a className="mx-auto lg:mx-0 hover:underline font-bold rounded-full mt-4 lg:mt-0 py-4 px-5 shadow opacity-75 gradient text-white" href="https://discord.gg/NDv2HdmTAD" target={`_blank`}>Discord</a>
            </li>
          </ul>
        </div>
      </div>
      <hr className="border-b border-gray-100 opacity-25 my-0 py-0"/>
    </nav>
  );
}

export default Navigation;
